import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpHelper } from '../helpers/http-helper';
import { AuthenticationService } from './authentication.service';
import { SettingsService } from './settings.service';
import { StorageManagerService } from './storage-manager.service';
import { ToastrService } from 'ngx-toastr';
import { ISubmissionDashboard } from '../models/submission-dashboard.model';
import { IApiResult } from '../models/api-result';
@Injectable()
export class SubmissionDashboardService {
  httpHelper: HttpHelper;

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService,
    private authService: AuthenticationService,
    private storageManagerService: StorageManagerService,
    private toastr: ToastrService,
  ) {
    // Define an instance of the http helper class that will be used to create httpHeader for api calls
    this.httpHelper = new HttpHelper(http, authService, storageManagerService);
  }

  getSubmissionDashboard(dateRangeLimit: string): Observable<ISubmissionDashboard[]> {
    const headers = this.httpHelper.createHttpHeaders();
    const settings = this.settingsService.getSettings();
    const apiUrl = settings.ApiGatewayUrl;
    const action = `ssdpds/v1/Submission/SubmissionDashboard?dateRangeLimit=${dateRangeLimit}`;
    return this.http.get(`${apiUrl}/${action}`, { headers: headers })
      .pipe(map(this.extractData),
        map(p => p.data),
        catchError(this.handleErrors));
  }

  downloadFile(submissionId: number): Observable<IApiResult> {
    const headers = this.httpHelper.createHttpHeaders();
    const settings = this.settingsService.getSettings();
    const url = `${settings.ApiGatewayUrl}/ssdpds/v1/Submission/GetSubmissionResponseFiles/${submissionId}`;
    return this.http.get(url, { headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleErrors));
  }

  private extractData(response: any) {
    if (response.status < 200 || response.status >= 300) {
      throw new Error('Bad response status: ' + response.status);
    }
    const body = response as IApiResult;
    return body;
  }

  // Error handling
  private handleErrors(error: any): Observable<any> {
    const GENERIC_ERROR_MSG = 'It looks like something went wrong. Try reloading the page or contacting support if this issue continues.';
    const bDisplayDetailMsg = error && error.error && error.error.isBusinessErrorMessage
      ? true
      : !!isDevMode();
    error.error = error && error.error && error.error.message && bDisplayDetailMsg
      ? error.error.message
      : GENERIC_ERROR_MSG;

    return throwError(error.error);
  }
}
